<footer class="bg-cd-on-surface text-white">
  <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
    <div class="grid grid-cols-2 md:grid-cols-4 gap-8">
      <!-- Brand -->
      <div class="col-span-2 md:col-span-1">
        <a routerLink="/" class="flex items-center gap-2 mb-3">
          <span class="material-symbols-outlined text-cd-primary-light text-2xl">forum</span>
          <span class="text-lg font-bold">ChatDigest</span>
        </a>
        <p class="text-sm text-gray-400 mb-4">
          AI-powered WhatsApp chat analysis for research and insights.
        </p>
      </div>

      <!-- Product -->
      <div>
        <h4 class="text-sm font-semibold text-white mb-3">Product</h4>
        <ul class="space-y-2">
          <li><a routerLink="/" fragment="features" class="text-sm text-gray-400 hover:text-white transition-colors">Features</a></li>
          <li><a routerLink="/pricing" class="text-sm text-gray-400 hover:text-white transition-colors">Pricing</a></li>
          <li><a routerLink="/faq" class="text-sm text-gray-400 hover:text-white transition-colors">FAQ</a></li>
        </ul>
      </div>

      <!-- Resources -->
      <div>
        <h4 class="text-sm font-semibold text-white mb-3">Resources</h4>
        <ul class="space-y-2">
          <li><a routerLink="/about" class="text-sm text-gray-400 hover:text-white transition-colors">About</a></li>
          <li><a href="https://github.com/DeanMaponga/whatsappSummary" target="_blank" rel="noopener" class="text-sm text-gray-400 hover:text-white transition-colors">GitHub</a></li>
        </ul>
      </div>

      <!-- Legal -->
      <div>
        <h4 class="text-sm font-semibold text-white mb-3">Legal</h4>
        <ul class="space-y-2">
          <li><a routerLink="/privacy-policy" class="text-sm text-gray-400 hover:text-white transition-colors">Privacy Policy</a></li>
          <li><a routerLink="/terms-of-service" class="text-sm text-gray-400 hover:text-white transition-colors">Terms of Service</a></li>
        </ul>
      </div>
    </div>

    <!-- Bottom -->
    <div class="border-t border-gray-700 mt-8 pt-8 flex flex-col sm:flex-row justify-between items-center gap-4">
      <p class="text-sm text-gray-400">&copy; 2026 ChatDigest &mdash; Midlands State University</p>
    </div>
  </div>
</footer>
